customClass